import * as uuid from 'uuid';

import { api } from 'common';

import { type ReactFlowBlockNode, type ReactFlowNode } from '../../../../types';
import { BlockType, FlowNodeType } from '../../../types';

export const FLOW_DEFINITION_STATE_TO_SCHEDULED_TRIGGERS_ENABLED: Record<
  api.FlowDefinition.FlowDefinitionState,
  'CanScheduleTriggers' | 'CannotScheduleTriggers'
> = {
  [api.FlowDefinition.FlowDefinitionState.Draft]: 'CanScheduleTriggers',
  [api.FlowDefinition.FlowDefinitionState.Review]: 'CanScheduleTriggers',
  [api.FlowDefinition.FlowDefinitionState.Published]: 'CanScheduleTriggers',
  [api.FlowDefinition.FlowDefinitionState.SoftDeleted]: 'CannotScheduleTriggers',
  [api.FlowDefinition.FlowDefinitionState.Superseded]: 'CannotScheduleTriggers',
};

export const defaultStartNodeLabelPrefix = 'Start';
export function getDefaultStartNodeConfig(): api.FlowDefinition.StartBlock['config'] {
  return {
    isStartBlock: true,
    entityType: 'None',
  };
}

export const DEFAULT_START_NODE_POSITION = { x: 4 * 16, y: 8 * 16 };

export function createStartNode(props: Pick<ReactFlowNode, 'position'>): ReactFlowBlockNode {
  return {
    id: uuid.v4(),
    data: {
      uiBlockType: BlockType.Start,
      label: 'Start',
      config: getDefaultStartNodeConfig(),
      returnType: api.FlowDefinition.ProducedType.Start,
    },
    type: FlowNodeType.Block,
    ...props,
  };
}
